import { client } from '../../axios/client';
import { contactsSet } from './contacts';

export const getListContactsAdvanced = (id_customer, token, filters = {}, offset = 0, limit = 20) => {
    return async (dispatch) => {
        try {
            // console.debug('[ContactsAdvanced] getListContactsAdvanced() called with:', { id_customer, offset, limit, filters });
            const params = {
                offset,
                limit,
                ...filters
            };

            const { data } = await client.get(`/contacts/advanced/${id_customer}`, {
                headers: { 'Authorization': `Bearer ${token}` },
                params
            });

            if (data.items.length === 0) {
                console.log('No se encontraron contactos con los filtros aplicados');
            }

            dispatch(contactsSet({
                contacts: data.items,
                loading: false,
                count: data.count
            }));

            return data;
        } catch (error) {
            console.error('Error obteniendo contactos avanzados:', error);
            alert('Error al obtener contactos', 'error');
            return { items: [], count: 0 };
        }
    };
};

export const getAgentsForFilter = (id_customer, token) => {
    return async (dispatch) => {
        try {
            const { data } = await client.get(`/contacts/agents/${id_customer}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });

            // console.debug('[ContactsAdvanced] Agents for filter loaded:', data);
            dispatch(setAgentsForFilter(data));
            return data;
        } catch (error) {
            console.error('Error obteniendo agentes:', error);
            return [];
        }
    };
};

// Action creators
export const setAgentsForFilter = (agents) => ({
    type: 'SET_AGENTS_FOR_FILTER',
    payload: agents
});

export const setAdvancedFilters = (filters) => ({
    type: 'SET_ADVANCED_FILTERS',
    payload: filters
});

export const clearAdvancedFilters = () => ({
    type: 'CLEAR_ADVANCED_FILTERS'
});

export const updateContactAdvanced = (contact) => ({
    type: 'UPDATE_CONTACT_ADVANCED',
    payload: contact
});

export const getListContactsByNameAdvanced = (first_name, id_customer, token, offset = 0, limit = 20) => {
    return async (dispatch) => {
        try {
            const consulta = { first_name, offset, limit };
            const { data } = await client.post(`/contacts/name/${id_customer}`, consulta, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });

            if (data.items.length === 0) {
                console.log('No se encontraron contactos con ese nombre');
            }

            dispatch(contactsSet({
                contacts: data.items,
                loading: false,
                count: data.count
            }));

            return data;
        } catch (error) {
            console.error('Error obteniendo contactos por nombre:', error);
            alert('No se encontraron contactos', 'error');
            return { items: [], count: 0 };
        }
    };
};
